$(document).ready(function() {
	if(!document.querySelector('.GPC0078')) return false;
	
	var component78 = {
		$el : $('.GPC0078'),
		init : function() {
			this.$el.find('.carousel-wrap').each(function() {
				if($(this).find('.carousel-box').length>1) {
					component78.runSlick($(this));
				} else {
					$(this).addClass('active');
				}
			});
			this.addAriaDescribedby();
			/* LGEGMC-1528 : 20210423 add */ 
			this.clickEvt(); 
			/*// LGEGMC-1528 : 20210423 add */ 
		},
		runSlick: function($obj) {
			var fontColor = 'black';
			/* LGECI-261 20201209 edit */
			if($obj.find('.carousel-box').eq(0).find('.text-area').hasClass('text-white')) {
				fontColor = 'white';
			}

			/* LGEIN-554, LGEBR-751 Start */
			var countryCode = $('html').data('countrycode'),
				slideDirLtr = countryCode == 'in' || countryCode == 'br' ? true : false;
			/* //LGEIN-554, LGEBR-751 End */

			$obj.on('init', function(slick){
				var $this = $(this);
				$this.find('.slick-slide').attr('role', 'tabpanel');
			})
			/* LGEITF-520 remove Start */
			/*.slick({
				infinite: slideDirLtr, // LGEIN-554
				listStyle: true, 
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows : true,
				dots: true,
				//adaptiveHeight: true,
				// lazyLoad: 'ondemand',
				autoplay: false, //LGEITF-424
				autoplaySpeed: 8000,
				prevArrow: carouselOptions.bigAnglePrev, // common.js variable
				nextArrow: carouselOptions.bigAngleNext, // common.js variable
				//appendDots:$obj.find('.slick-indicator .slick-dot-wrap')
				appendDots:$obj.next().find('.slick-dot-wrap')
			});*/
			/* LGEITF-520 remove End */
			
			/* LGEITF-520 Start */
			var _this = $obj.closest('.GPC0078')[0];
			var primaryKey = $(_this).data('primarykey');
			
			var slider = new KeenSlider('#keen-slider-'+primaryKey, {
				loop : slideDirLtr,
				//slidesPerView : 1,
				arrows : true,
				dots: true,
				autoplay: true,
				autoplaySpeed: 8000,
				created: function (instance) {
					instance.settings(_this, instance);
					/* LGEITF-577 Start */
					$obj.siblings().find('.slide-pause').on('click',function(e){
						e.preventDefault();
						if ($(this).hasClass('pause')) {
							$(this).removeClass('pause').addClass('play');
							$(this).text($(this).attr('data-title-play'));
							instance.autoplay(false, instance);
						} else {
							$(this).removeClass('play').addClass('pause');
							$(this).text($(this).attr('data-title-stop'));
							instance.autoplay(true, instance);
						}
					});
					/* LGEITF-577 End */
				},
				slideChanged(instance) {
					instance.updateClasses(_this, instance);
				},
				prevArrow: carouselOptions.bigAnglePrev, // common.js variable
				nextArrow: carouselOptions.bigAngleNext, // common.js variable
				appendDots:$obj.siblings().find('.slick-dot-wrap')[0],
				duration: 1000,
				dragStart: function(instance){
				},
				dragEnd: function(instance){
					
				},
				afterChange(instance){				
					var currentSlide = instance.details().absoluteSlide;
					var nextSlide = instance.details().absoluteSlide + 1;
					if($obj.find('.slick-current .text-area').hasClass('text-white')) {
						fontColor = 'white';
					} else {
						fontColor = 'black';
					}
					$obj.removeClass('slick-white').removeClass('slick-black').addClass('slick-'+fontColor);
					
					$obj.find('.carousel-box[data-slick-index='+nextSlide+'] .visual-area img[data-src]').addClass('lazyload');
					
					var $currentvideo = $obj.find('.carousel-box[data-slick-index='+currentSlide+'] .animation-area video:visible');
					if($currentvideo.length && !(!!$currentvideo.find('source').attr('src'))){
						$currentvideo.find('source').attr('src', $currentvideo.find('source').data('src'))
						$currentvideo.get(0).load()
					}
					
					var $video = $obj.find('.carousel-box[data-slick-index='+nextSlide+'] .animation-area video:visible');
					if($video.length && !(!!$video.find('source').attr('src'))){
						$video.find('source').attr('src', $video.find('source').data('src'))
						$video.get(0).load()
					}
				}
			});
			/* LGEITF-520 End */
			
			$obj.addClass('active');

			$obj.addClass('slick-'+fontColor);
			/* LGEITF-520 remove Start */
			/*$obj.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				$obj.find('.carousel-box[data-slick-index='+nextSlide+'] .visual-area img[data-src]').addClass('lazyload');
			});
			$obj.on('afterChange', function(event, slick, currentSlide){
				if($obj.find('.slick-current .text-area').hasClass('text-white')) {
					fontColor = 'white';
				} else {
					fontColor = 'black';
				}
				$obj.removeClass('slick-white').removeClass('slick-black').addClass('slick-'+fontColor);
			});

			$obj.next().find('.slide-pause').addClass('active').on('click',function(e){
				e.preventDefault();
				if ($(this).hasClass('pause')) {
					$(this).removeClass('pause').addClass('play');
					$(this).text($(this).attr('data-title-play'));
					$(this).attr('aria-label',$(this).attr('data-title-play'));
					$obj.slick('slickPause');
				} else {
					$(this).removeClass('play').addClass('pause');
					$(this).text($(this).attr('data-title-stop'));
					$(this).attr('aria-label',$(this).attr('data-title-stop'));
					$obj.slick('slickPlay');
				}
			});*/
			/* //LGECI-261 20201209 edit */
			// $obj.find('.slide-pause').trigger('click');
			//LGEITF-424 s
			/*setTimeout(function(){
				$obj.slick('slickPlay');
			}, 8000);*/
			//LGEITF-424 e
			/* LGEITF-520 remove End */
		},
		addAriaDescribedby: function(){
			var _this = component78;
			var waNumber = 0;
			$(_this.$el).find('.text-area').each(function() {
				var $target;
				if($(this).find('.title') && !$(this).find('.title').is(':empty')) {
					$target = $(this).find('.title');
				}
				if($target) {
					$target.attr('id', 'waGPC0078_'+waNumber);
					$(this).find('a.btn').attr('aria-describedby', 'waGPC0078_'+waNumber);
					$(this).find('a.link-text').attr('aria-describedby', 'waGPC0078_'+waNumber);
					waNumber++;
				}
			});
		},
		/* LGEGMC-1528 : 20210423 add */ 
		clickEvt : function(){ 
			var _this = component78; 
			$(_this.$el).find('.cta a').off('click').on('click', function(e){ 
				var $btn = $(this); 
				adobeTrackEvent('hero_click', { 
					hero_key_subject : $btn.parents('.cta').siblings('.text-block').find('.title').text(), //hero 제목 ​
					hero_key_order : $btn.parents('li.carousel-box').data('slick-index') + 1, //hero 순번 ​
					//hero_key_upload_date : "20210125", //hero 업로드된 날짜 ​
					hero_key_btn_order : $btn.parent('span').index() + 1, //hero 내 버튼 순번 ​
					hero_key_btn_title : $btn.text(),  // btn 타이틀 ​
					page_event : { 
						hero_click : true 
					} 
				}); 
			}) 
		} 
		/*// LGEGMC-1528 : 20210423 add */ 
	};
	component78.init();
	
	/* LGEPA-508, LGCOMSPEED-6 Start */
	var timer = null;
	function countDownTimer() {
		if ($(document).countdown === undefined) {
			timer = setTimeout(countDownTimer, 100); 
		} else {
			if(timer !== null) clearTimeout(timer);
			$(document).find('.GPC0078 .countdown-box .count-timer-box').each(function() {
				var $count_target = $(this);
				var $countdate = $count_target.data('countdown-date');
				/* LGEPA-825 Start */
				var $timeUtc = $count_target.data('time-utc');
				if($timeUtc !=='' && typeof $timeUtc !=='undefined'){ //LGEITF-914
					if(new Date().getTimezoneOffset()*60000 == $timeUtc){
						var iso = new Date(new Date($countdate).getTime() -540*60000)/1;
						var setDate =new Date(iso - new Date().getTimezoneOffset() * 60000);
					}else{
						var iso = new Date(new Date($countdate).getTime()- $timeUtc -540*60000)/1;
						var setDate =new Date(iso);
					} 
					var year = setDate.getFullYear();
					var month = ('0' + (setDate.getMonth() + 1)).slice(-2);
					var day = ('0' + setDate.getDate()).slice(-2);
					var hours = ('0' + setDate.getHours()).slice(-2); 
					var minutes = ('0' + setDate.getMinutes()).slice(-2);
		
					var timeString = hours + ':' + minutes;
					var dateString = year + '/' + month  + '/' + day;
					var setCountdownDate = dateString+' '+timeString;
					$count_target.attr('data-countdown-date',setCountdownDate);
					$count_target.data('countdown-date',setCountdownDate); 
				}
				/* LGEPA-825 End */
				/* LGEDE-629 Start */
				var labelsArr = ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds'];
				var labels1Arr = ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second'];
				if($count_target.data('countdown-labels') && $count_target.data('countdown-labels') != 'component-countdown-labels'){
					labelsArr = $count_target.data('countdown-labels').split(',');
				}
				if($count_target.data('countdown-label-single') && $count_target.data('countdown-label-single') != 'component-countdown-label-single'){
					labels1Arr = $count_target.data('countdown-label-single').split(',');
				}
				$countdate = $count_target.data('countdown-date');
				$count_target.countdown({
					labels: labelsArr, 
					labels1: labels1Arr, 
					until: new Date($countdate),
					//timezone: +9, // seoul 기준
					format: 'DHMS',
					padZeroes: true, // 00 표시
				});
				/* LGEDE-629 End */
			});
		}
	}
	if(!!document.querySelector('.GPC0078 .countdown-box')) countDownTimer();
	/* LGEPA-508, LGCOMSPEED-6 End */
	
	/* LGEITF-520 Start */
	$(window).resize(function(){
	    var $video = component78.$el.find('.carousel-box.slick-current .animation-area video:visible'); 
		if($video.length && !(!!$video.find('source').attr('src'))){
			$video.find('source').attr('src', $video.find('source').data('src'))				
			$video.get(0).load()
		}
	});
	/* LGEITF-520 End */
});

/* LGCOMSPEED-8 Start */
$(window).on('load', function() {
	$('.GPC0078').each(function() {
		$(this).find("> .carousel-wrap").css('min-height', 'auto');
	})
})
/* LGCOMSPEED-8 End */